import { render, staticRenderFns } from "./banitem.vue?vue&type=template&id=77a2dbd0&scoped=true&"
import script from "./banitem.vue?vue&type=script&lang=js&"
export * from "./banitem.vue?vue&type=script&lang=js&"
import style0 from "./banitem.vue?vue&type=style&index=0&id=77a2dbd0&lang=scss&scoped=true&"
import style1 from "./banitem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2dbd0",
  null
  
)

component.options.__file = "banitem.vue"
export default component.exports